import { defineComponent, type PropType } from "vue";
import type { Product } from "@orie/sdk";
import type { ProductQueryFilter } from "@/types/models";
import Grid, { type GridLayout } from "../grid/Grid.block";
import type { ProductContentLayout, ProductSourceType } from "./Product.block";
import Slider, { type SliderContent } from "../slider";
import type { ComponentBlocks } from "blocks";

export interface ProductsContent {
  layout?: GridLayout | "slider";
  itemLayout?: ProductContentLayout;
  layoutOptions?: ComponentBlocks["grid-block"]["layoutOptions"];
  slider?: Omit<SliderContent, "columns">;
  data: string[] | Product[] | ProductQueryFilter;
}

declare module "blocks" {
  export interface ComponentBlocks {
    "products-block": ProductsContent;
  }
}

export default defineComponent({
  name: "Products",
  props: {
    content: {
      type: Object as PropType<ProductsContent>,
      required: true,
    },
  },
  setup(props) {
    let data: Ref<(string | Product)[]>;

    if (Array.isArray(props.content.data)) {
      data = ref(props.content.data);
    } else {
      // fetch data
      const apiData = useProducts({
        filter: props.content.data,
      });
      data = apiData.products;
    }

    return {
      data,
    };
  },
  render() {
    const columns = this.data.map((source: ProductSourceType<any>) =>
      defineComponentBlock({
        component: "product-block",
        layout: this.content.itemLayout,
        layoutOptions: this.content.layoutOptions,
        source,
      })
    );

    if (this.content.layout === "slider") {
      return h(Slider, {
        content: {
          ...this.content.slider,
          columns,
        },
      });
    }

    return h(Grid, {
      content: {
        layout: this.content.layout,
        columns,
      },
    });
  },
});
